import SurveyPopover from '@/components/Surveys/SurveyPopover';
import { hDeepCopy } from '@/utils/helpers';

export default {
  name: 'SurveyResultsItem',

  components: {
    SurveyPopover
  },

  props: {
    survey: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isSurveyLoading: false,
      isSurveyPopoverVisible: false,
      preparedAnswersForSurvey: []
    };
  },

  computed: {
    currentCallSurvey() {
      return this.$store.getters['campaign/currentCallSurvey'];
    },
    questionsList() {
      return this.$store.getters['campaign/surveyQuestions'];
    },
  },

  methods: {
    async getSurvey() {
      this.isSurveyLoading = true;
      await this.$store.dispatch('campaign/getSurveyResult', { wh1Uuid: this.survey._uuid_wh1, surveyUuid: this.survey._survey_uuid });
      if (this.currentCallSurvey.some(item => !!item._answer)) {
        const answersForSurveyCopy = hDeepCopy(this.currentCallSurvey);
        this.preparedAnswersForSurvey = answersForSurveyCopy.map(item => ({
          questionId: item._question_id,
          answer: item._answer
        }))
      }
      this.isSurveyPopoverVisible = true;
      this.isSurveyLoading = false;
    },
  },
};
